export default "__VITE_ASSET__C0Cr8jvH__"